var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcShops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m54.598 662.115-1.8-5.437a1.034 1.034 0 0 0-.98-.709h-16.02c-.433 0-.844.274-.98.709l-1.778 5.437c-.228.663.274 1.348.98 1.348h.593v12.68c0 .275.228.503.501.503h17.41a.506.506 0 0 0 .502-.502v-12.68h.592c.707 0 1.185-.686.98-1.349zm-9.503 7.928H36.14v-6.557h8.956v6.557zm6.404 5.072h-4.854v-11.629H51.5v11.63z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "evenodd",
    transform: "translate(-33 -655)",
    xlinkHref: "#a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShops);
export default __webpack_public_path__ + "static/media/ic-shops.94094fdb48ec03a07c33ea54a3861ec5.svg";
export { ForwardRef as ReactComponent };